import router from "@/router";

function goToOrder (id) {
    router.push({ params: { id }})
}

export {
    goToOrder
}
